import { CSWebPlayerCore } from "@clipsource/media-player";
import { CsBaseComponent } from "../cs-base-component/cs-base-component";

// @ts-ignore
import template from './cs-hls-video.html';
import { CSMediaPlayerSkin } from "@clipsource/media-player-skin";

class CsHlsVideo extends CsBaseComponent {
    static acceptedAttributes = ['src', 'snapshot', 'hero'];

    static get observedAttributes() {
        return this.acceptedAttributes;
    }

    protected player: CSWebPlayerCore | null = null;
    protected playerSkin: CSMediaPlayerSkin | null = null;

    getTemplate(): string {
        return template;
    }

    connectedCallback() {
        super.connectedCallback();
        this.setupClipsourcePlayer();
    }

    disconnectedCallback() {
        this.player?.destroy();
        this.playerSkin?.destroy();
    }

    setupClipsourcePlayer() {
        const src = this.getAttribute("src");
        const containerElement = this.querySelector<HTMLDivElement>(`#${this.elementId}`);
        const poster = this.getAttribute('snapshot') || undefined;

        const isHero = this.getAttribute('hero') === '1';

        if(!src || !containerElement) return;

        const autoPlay = !!isHero;

        const player = new CSWebPlayerCore({ src, containerElement, poster: poster, loop: !!isHero, hlsLevel: !!isHero ? "high": undefined, autoPlay, muted: autoPlay, allowPictureInPicture: !isHero, disableChromecast: !!isHero });
        this.player = player;

        player.once("loaded", this.setVideoOverlayHeight.bind(this));
        window.addEventListener('resize', this.setVideoOverlayHeight.bind(this));

        if(!isHero) {
            this.playerSkin = new CSMediaPlayerSkin(player, { useFullPageButton: false });
        }

        player.load();
    }

    setVideoOverlayHeight() {
        const videoContainerElement = this.player?.getContainerElement();
        const videoOverlay = this.getVideoOverlayElement();
        if(!videoContainerElement || !videoOverlay) return;

        const videoHeight = videoContainerElement.offsetHeight + 78.75;

        if (videoHeight > 0) {
            videoOverlay.style.height = `${videoHeight}px`;
        }
    }

    getVideoOverlayElement(): HTMLElement | null {
        return document.querySelector("#videoOverlay");
    }
}

customElements.define('cs-hls-video', CsHlsVideo);